import { render, staticRenderFns } from "./global-settings.vue?vue&type=template&id=48b33608&scoped=true&"
import script from "./global-settings.js?vue&type=script&lang=js&"
export * from "./global-settings.js?vue&type=script&lang=js&"
import style0 from "./global-settings.scss?vue&type=style&index=0&id=48b33608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b33608",
  null
  
)

export default component.exports